import { Box, Chip, styled, Switch, Typography } from '@mui/material'

const StyledSwitch = styled(Switch)(({ theme, disabled }) => ({
    padding: 8,
    '& .MuiSwitch-switchBase': {
        '&.Mui-checked': {
        '& .MuiSwitch-thumb': {
            backgroundColor: disabled? "#C0C4CF": '#cccccc',
            margin: "2px 2px",
        },
        '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: disabled? "#F3F4F8": theme.palette.primary,
            border: `none`,
        },
        },
    },
    '& .MuiSwitch-track': {     
      borderRadius: 22 / 2,
      backgroundColor: disabled? "#F3F4F8": "transparent",
      border: "2px solid #656B77",
      opacity: 1,
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      backgroundColor: disabled? "#C0C4CF": '#656B77',
      width: 16,
      height: 16,
      margin: "2px 3px",
    },
  }));

  
const RecommendedApp = ({ name, description, enabled, badge, icon, background, index, onToggle, disabled, hide }) => {
    const icons = import.meta.glob('/src/assets/*', { eager: true });
    const iconPath = icons[`/src/assets/${icon}`]?.default;

    return <Box className={`flex w-full gap-5 ${hide? "hidden": ""}`}>
        <img   
            className="min-w-[48px] min-h-[48px] w-[48px] h-[48px] rounded-xl"
            style={{
                background,
                objectFit: 'none'
            }}
            src={iconPath}
            alt='icon'
        />
        <Box className="flex flex-col flex-grow text-left gap-1">
            <Box component={'div'} className='flex gap-3'>
                <Typography variant='h6'>{name}</Typography>
                {badge && <Chip label={<Typography variant='h6' fontSize={10} color='primary'>{badge}</Typography>} sx={{
                    display: "none",
                    backgroundColor: '#F6F8FF',
                    maxWidth: 78,
                    maxHeight: 24,
                }}/>}
            </Box>
            <Typography variant='body2'>{description}</Typography>
        </Box>
        <StyledSwitch className="my-auto" disabled={disabled} checked={enabled} onChange={(e) => {
            onToggle(index, e.target.checked)
        }}></StyledSwitch>
    </Box>
}

export default RecommendedApp